import './config';
import {apiBaseUrl} from './config';
import {getBaseHeader} from './utils';
import SfpBaseService from './sfp-base-service';

const PPI_INVESTMENT_PROJECT_GRANTS_YEARS = 'ppis/investment/project/grants/years';

export default class PPIInvestmentProjectGrantYearService extends SfpBaseService {

  static updatePPIInvestmentProjectGrantYear(year_id, amount) {
		var values = {amount}
    const body = JSON.stringify({ppi_investment_project_grant_year: values});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/ppis/${year_id}/investment/project/grant/year`, {body, headers, method: "PUT"})
      .then(super.returnResponse);
  }

}



// WEBPACK FOOTER //
// ./src/service/sfp/ppi-investment-project-grant-year-service.js